import { render, staticRenderFns } from "./ButtonAudio.vue?vue&type=template&id=79b82680"
import script from "./ButtonAudio.vue?vue&type=script&lang=js"
export * from "./ButtonAudio.vue?vue&type=script&lang=js"
import style0 from "./ButtonAudio.vue?vue&type=style&index=0&id=79b82680&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports